export default __webpack_public_path__ + "static/media/prod-management.056558a6.jpeg";